import React, { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant/Routes";
import Theme from "../../utils/Theme";
import { LoginContext } from "../../context/Login/LoginContext";
import { Dropdown } from "flowbite-react";
import { AiOutlineMenu } from "react-icons/ai";

export default function Nav() {
  const loginContext = useContext(LoginContext);

  const location = useLocation();

  const navigate = useNavigate();

  return (
    <div>
      <div className="h-16 rounded-b-lg bg-lightSecondary dark:bg-darkSecondary dark:text-lightSecondary  p-2 pl-0 pr-4">
        <div className="flex justify-between items-center">
          <p className=" mt-1 font-bold text-xl cursor-pointer">
            سامانه یکپارچه انگ طلا
          </p>
          <div className="flex items-center">
            <Theme />
            {loginContext.loginState ? (
              <div>
                <Dropdown
                  color="auto"
                  label={<AiOutlineMenu className="text-2xl ml-2" />}
                >
                  <Dropdown.Item>
                    <a href="http://iranrey.ir/Sample.pdf" target="_blank">
                      دانلود نمونه پاکت
                    </a>
                  </Dropdown.Item>
                </Dropdown>
              </div>
            ) : null}
          </div>
        </div>

        {/* <div className="flex">
          <p
            className={`sm:mx-6 mx-3 px-3 font-bold sm:text-md text-sm  cursor-pointer border-2 p-2 border-yellow-400 rounded-lg ${
              location.pathname == ROUTES.INQUIRY
                ? "bg-yellow-400 text-darkTextPrimary"
                : "text-yellow-400"
            }`}
          >
            <Link to={ROUTES.INQUIRY}>استعلام</Link>
          </p>
          {!loginContext.loginState ? (
            <>
              <p
                className={`sm:mx-2 px-5 font-bold sm:text-md  text-sm cursor-pointer border-2 p-2 border-green-700 rounded-lg ${
                  location.pathname == ROUTES.LOGIN
                    ? "bg-green-700 text-darkTextPrimary"
                    : "text-green-700"
                }`}
              >
                <Link to={ROUTES.LOGIN}>ورود</Link>
              </p>
              <p
                className={`mx-2 px-3 font-bold sm:text-md text-sm cursor-pointer border-2 p-2 border-blue-700 rounded-lg ${
                  location.pathname == ROUTES.SIGNUP
                    ? "bg-blue-700 text-darkTextPrimary"
                    : "text-blue-700"
                }`}
              >
                <Link to={ROUTES.SIGNUP}>ثبت نام</Link>
              </p>
            </>
          ) : (
            <>
              <div
                className={`mx-2 font-bold sm:text-md text-sm cursor-pointer border-2 p-2 border-green-700 rounded-lg ${
                  location.pathname == ROUTES.ADDPAKAT
                    ? "bg-green-700 text-darkTextPrimary"
                    : "text-green-700"
                }`}
              >
                <Link to={ROUTES.ADDPAKAT}>افزودن پاکت</Link>
              </div>
              <div
                className="flex text-2xl m-2  dark:text-lightSecondary text-darkSecondary"
                onClick={() => {
                  loginContext.logout();
                  navigate(ROUTES.INQUIRY);
                }}
              >
                <BiLogOut />
              </div>
            </>
          )}
        </div> */}
      </div>
    </div>
  );
}
